import appConstants from '../../../../../../appConstants';
import { DateTimeEditor, NumericEditor } from '@dataGrid/components/cellEditors';
import { DateTimeFilter, MultiSelectFilter } from '@dataGrid/components/columnFilters';
import { setTimeFromDateTime } from '@dataGrid/gridUtilities';

class GridConfig {
  constructor(configuration) {
    const config = configuration || {};
    this.name = 'GridConfiguration';
    this.config = GridConfig.getConfiguration(config);
  }
  static getConfiguration(config) {
    return GridConfig.getDefaultConfiguration();
  }

  static getDefaultConfiguration() {
    return {
      title: appConstants.gridNames.optimizationDriverPreferences,
      enableFilter: true,
      rowDeselection: true,
      rowSelection: 'multiple',
      defaultColDef: {
        sortable: true,
        resizable: false
      },
      columns: [
        {
          headerName: 'Start Time',
          field: 'startTime',
          headerTooltip: 'Start Time',
          minWidth: appConstants.columnWidth.W_120,
          editable: true,
          valueSetter: setTimeFromDateTime,
          cellEditor: DateTimeEditor,
          cellEditorPopup: true,
          cellEditorParams: {
            DATETYPE: appConstants.DATETYPES.TIME
          },
          filter: DateTimeFilter,
          filterParams: {
            DATETYPE: appConstants.DATETYPES.TIME
          }
        },
        {
          headerName: 'Driver Count',
          field: 'driverCount',
          headerTooltip: 'Driver Count',
          minWidth: appConstants.columnWidth.W_120,
          editable: true,
          cellEditor: NumericEditor,
          filter: MultiSelectFilter
        }
      ]
    };
  }
}

export default GridConfig;
